import { Breadcrumb, Container } from 'react-bootstrap'
import { buildHref, buildQuery, pathURL } from '~/utils'

import { AppCommonProps } from 'types/app'
import { DEFAULT_PAGE_SIZE } from '~/utils/constants'
import { END } from 'redux-saga'
import Head from 'next/head'
import Link from 'next/link'
import { ListVideosPag } from '~/components/common'
import MainLayout from '~/layout/MainLayout'
import { Meta } from '~/components/common/seo'
import { NextPage } from 'next'
import React from 'react'
import { commonMiddleware } from '~/middleware'
import config from '~/config'
import { formatNumberWithCommas } from '~/utils/formatter'
import { loadVideosByTag } from '~/store/video/actions'
import { routes } from '~/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { withI18n } from '~/hocs'
import { wrapper } from '~/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { makeSelectIsAuthenticated, makeSelectIsPremium, makeSelectProfile } from '~/store/auth/selector'
import GoogleAdsTagSearch3PagePremium from '~/components/common/Ads/GoogleAdsTagSearch3PremiumPage'
import GoogleAdsTagSearch3Page from '~/components/common/Ads/GoogleAdsTagSearch3Page'
import { CheckNoAds } from "~/utils"

const VideoTag: NextPage<AppCommonProps> = ({ t, lng, videos, meta, headerData, isAuthen, isPremium, profile }) => {
  const router = useRouter()
  const { tag } = router.query
  const path = routes.tag.as(tag)
  const page = meta.page
  const onChangePagination = (e: any) => {
    router.push({
      query: {
       ...router.query,
       page:e.page,
      }
     })
  }
  const pageOneHref = React.useMemo(() => buildHref({
    pathname: routes.tag.href,
    query: { tag, page_size: meta.page_size, sort_by: meta.sort_by },
    lng,
  }), [])

  const metaTitle = t('discovery:page_title_search', { term: tag })

  return (
    <MainLayout path={path} headerData={headerData}>
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <Meta
        url={pathURL(routes.discovery.href, lng)}
        title={metaTitle}
        description={t('discovery:page_description_search', { term: tag })}
        image={config.image.default_seo}
        keywords={`${tag}, ${t('discovery:page_keywords')}`}
        type="article"
        twitter={true}
      />

      <Container>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link href={routes.home.href} locale={lng}>
              {t('home')}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active={page === 1}>
            <Link href={pageOneHref} >
              {tag}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {/* {t('page')} {page} */}
            検索結果
          </Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      <ListVideosPag
        head={
          <>
            <span className="text-secondary" style={{ fontSize: '1rem' }}>
              全
            </span>
            <span className="bold">{formatNumberWithCommas(meta.total)}</span>

            <span className="text-secondary" style={{ fontSize: '1rem' }}>
              件中
              {meta.to > 0 && (
                <span>
                  /{meta.from}〜 {meta.to}件を表示
                </span>
              )}
            </span>
          </>
        }
        page={page}
        meta={meta}
        videos={videos}
        loading={false}
        href={buildHref({
          pathname: routes.tag.href,
          query: { tag, page: '*', page_size: meta.page_size, sort_by: meta.sort_by },
          lng,
        })}
        pageOneHref={pageOneHref}
        onChangePagination={onChangePagination}
        isAuthen={isAuthen}
        isPremium={isPremium}
        profile={profile}
      />
      {
      !CheckNoAds(profile?.premium_info) && <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: '300px',
          minHeight: '90px',
          marginBottom: "20px"
        }}
        className='google-ads bg-light'
      >
        {
          isPremium ? <GoogleAdsTagSearch3PagePremium /> : <GoogleAdsTagSearch3Page />
        }
        </div>
      }
    </MainLayout>
  )
}
export const getServerSideProps = wrapper.getServerSideProps(async ctx => {
  const { store, locale, query } = ctx
  store.dispatch(loadVideosByTag({
    lng: locale,
    tag_name: query.tag,
    page: query.page || 1,
    limit: query.page_size || DEFAULT_PAGE_SIZE,
    sort_by: query.sort_by || "-download_count",
  }))
  store.dispatch(END)
  let commonProps = {}
  await Promise.all([
    store.sagaTask.toPromise(),
    commonMiddleware(ctx).then(res => {
      commonProps = res
      commonProps.headerData.has_search = true
    }),
  ])
  const state = store.getState()
  return {
    props: {
      ...commonProps,
      videos: state.video.videosByTag,
      meta: state.video.videosByTagMeta,
      ...(await serverSideTranslations(locale, ['common', 'discovery'])),
    },
  }
})
const mapStateToProps = createStructuredSelector({
  isAuthen: makeSelectIsAuthenticated(),
  isPremium: makeSelectIsPremium(),
  profile: makeSelectProfile(),
})
export default connect(mapStateToProps)(withI18n(VideoTag))
